import React from "react";

import RulesSvg from "../../assets/images/icons/tasks/white.svg";

export const RulesIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RulesSvg}
        alt={alt || "Rules"}
    />
);
